//  AWS CloudWatch RUM
(function () {
  const enabled = import.meta.env.VITE_ENABLE_RUM === 'true';
  if (!enabled) return;

  const appId = import.meta.env.VITE_AWS_RUM_APP_ID;
  const appVersion = import.meta.env.VITE_APP_VERSION;
  const region = import.meta.env.VITE_AWS_RUM_REGION;
  const scriptUrl = import.meta.env.VITE_AWS_RUM_SCRIPT_URL;
  const endpoint = import.meta.env.VITE_AWS_RUM_ENDPOINT;

  (function (n, i, v, r, s, c, x, z) {
    x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
    window[n] = function (c, p) {
      x.q.push({ c: c, p: p });
    };
    z = document.createElement('script');
    z.async = true;
    z.src = s;
    document.head.insertBefore(z, document.head.getElementsByTagName('script')[0]);
  })('cwr', appId, appVersion, region, scriptUrl, {
    sessionSampleRate: 1,
    endpoint,
    telemetries: ['performance', 'errors', 'http'],
    allowCookies: true,
    enableXRay: false,
    signing: true,
  });
})();
